var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"input",attrs:{"maxlength":"18","value":_vm.value},on:{"focus":_vm.onFocus,"input":_vm.onInput,"keydown":function($event){return _vm.$emit('keydown', $event)},"blur":_vm.onBlur}},'v-text-field',_vm.attributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }